export enum BoxComponentType {
	INPUT = 'Input',
	TEXTAREA = 'Textarea',
	SELECT = 'Select',
	SUBMIT = 'Submit',
	BUTTON = 'Button',
	CHECKBOX = 'Checkbox',
	CHECKBOXLIST = 'CheckboxList',
	RADIOLIST = 'RadioList',
	RATING = 'Rating',
	CHOOSER = 'Chooser',
	DIV = 'Div',
	HTML = 'HTML',
}
